import "ol/ol.css";
import Map from "ol/Map";
import View from "ol/View";
import { HistoryControl } from "./olExtended";
import { defaults as defaultControls } from "ol/control";
import { Tile as TileLayer, Vector as VectorLayer } from "ol/layer";
import VectorSource from "ol/source/Vector";
import Feature from "ol/Feature";
import Point from "ol/geom/Point";
import { OSM, XYZ } from "ol/source";
import {
  addLayers,
  sectorLayer,
  zoneLayer,
  placesParkingLayer,
  initStyle,
} from "./parkingGIS";
import { Style } from "ol/style";
import Icon from "ol/style/Icon";
import IconOrigin from "ol/style/IconOrigin";
import IconAnchorUnits from "ol/style/IconAnchorUnits";

import { getSecteurFromId, matMatchingPolygon } from "./sectorServices";
import { getZoneFromId, matMatching } from "./zoneServices";

import { simpleReverseGeocoding, simpleGeocoding } from "./exyztGIS";
import { featureVisible } from "./olExtended";

import "ol-ext/dist/ol-ext.css";
import LayerSwitcher from "ol-ext/control/LayerSwitcher";

import { Modify } from "ol/interaction";
import Collection from "ol/Collection";
import { toLonLat, fromLonLat } from "ol/proj";

var map;
var zoomMax = 19;

var ControleCoordReproj;

var ctlFeature = null;
var ctlcloneFeature = null;
var cloning = true;
var vectorSource = null;
var svgGreen = `<svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24"><path fill="green" d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" /></svg>`;
var svgOrange = `<svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24"><path fill="orange" d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" /></svg>`;
var markerStyle = new Style({
  image: new Icon({
    anchorOrigin: IconOrigin.TOP_LEFT,
    anchorXUnits: IconAnchorUnits.FRACTION,
    anchorYUnits: IconAnchorUnits.FRACTION,
    anchor: [0.5, 1],
    src: "data:image/svg+xml;utf8," + svgGreen,
  }),
});
var markerUpdatedStyle = new Style({
  image: new Icon({
    anchorOrigin: IconOrigin.TOP_LEFT,
    anchorXUnits: IconAnchorUnits.FRACTION,
    anchorYUnits: IconAnchorUnits.FRACTION,
    anchor: [0.5, 1],
    src: "data:image/svg+xml;utf8," + svgOrange,
  }),
});
var layerSwitcher;

var geocodingApiUrl;
var secteurs;
var zones;
var onAddressChange;
var onCoordsChange;
var onSectorChange;
var onZoneChange;
var onMapMatchingProcess2;
var dedicatedStreetNumber;

var currentSecteur = null;
var updateSecteur = function (value) {
  currentSecteur = getSecteurFromId(secteurs, value);
};
function processSecteur(code) {
  updateSecteur(code);
  onSectorChange(currentSecteur);
}

var currentPlaceFeature = null;

var currentZone = null;
var updateZone = function (value) {
  currentZone = getZoneFromId(zones, value);
};
function processZone(code) {
  updateZone(code);
  onZoneChange(currentZone);
}

var mapMatchingProces = function (coord) {
  var coordinate = toLonLat(coord).map(function (val) {
    return val.toFixed(12);
  });

  simpleReverseGeocoding(
    geocodingApiUrl,
    coordinate[0],
    coordinate[1],
    function (json) {
      if (json.features.length === 0) {
        onAddressChange({});
        return;
      }

      onAddressChange({
        streetNumber:
          dedicatedStreetNumber &&
          json.features[0].properties.type === "housenumber"
            ? json.features[0].properties.housenumber
            : null,
        address:
          dedicatedStreetNumber &&
          json.features[0].properties.type === "housenumber"
            ? json.features[0].properties.street
            : json.features[0].properties.name,
        city: json.features[0].properties.city,
        postalCode: json.features[0].properties.postcode,
      });
    },
    function (error) {
      onAddressChange({});
    }
  );

  mapMatchingProces2(coord);
};

var mapMatchingProces2 = function (coord) {
  matMatching(zoneLayer, coord, function (feature) {
    var properties = feature !== null ? feature.getProperties() : null;
    processZone(properties ? properties.code : null);
  });

  matMatchingPolygon(sectorLayer, coord, function (properties) {
    processSecteur(properties ? properties.code : null);
  });

  //clean old place
  if (currentPlaceFeature) {
    currentPlaceFeature.set("selected", false);
  }

  matMatching(placesParkingLayer, coord, function (feature) {
    if (feature !== null) {
      //select new place
      feature.set("selected", true);
      currentPlaceFeature = feature;
    }
  });

  // onMapMatchingProcess2();
};

function initControleFeature() {
  ctlFeature = new Feature({
    geometry: new Point(ControleCoordReproj),
  });

  ctlFeature.setStyle(markerStyle);

  ctlcloneFeature = ctlFeature.clone();

  featureVisible(ctlcloneFeature, false);

  vectorSource = new VectorSource({
    features: [ctlFeature, ctlcloneFeature],
  });

  var vectorLayer = new VectorLayer({
    name: "Contrôle",
    source: vectorSource,
  });

  map.addLayer(vectorLayer);
  vectorLayer.setZIndex(1001);

  var c = new Collection([ctlFeature]);
  var modifyInteraction = new Modify({
    features: c,
  });
  cloning = true;
  map.addInteraction(modifyInteraction);
  var onModifyStart = function (event) {
    if (cloning) {
      ControleBeginUpdated();

      cloning = false;
    }
  };

  var onModifyEnd = function (event) {
    var coord = event.mapBrowserEvent.coordinate;
    updateControle(coord);

    ControleEndUpdated();

    mapMatchingProces(coord);
    onMapMatchingProcess2();
  };

  modifyInteraction.on("modifystart", onModifyStart);
  modifyInteraction.on("modifyend", onModifyEnd);
}

function revertControleFeature(coord) {
  ctlFeature.getGeometry().setCoordinates(coord);

  featureVisible(ctlcloneFeature, false);
  ctlFeature.setStyle(markerStyle);
  cloning = true;
}

function history() {
  goToControle(ControleCoordReproj, true);
  revertControleFeature(ControleCoordReproj);
  mapMatchingProces(ControleCoordReproj);
  onMapMatchingProcess2();
}

function goToControle(coord, init) {
  var view = map.getView();
  view.setCenter(coord);
  if (init) {
    view.setZoom(zoomMax);
    view.setRotation(0);
  }
}

function updateControle(coord) {
  var coordinate = toLonLat(coord);
  onCoordsChange(coordinate);
}

function ControleBeginUpdated() {
  featureVisible(ctlcloneFeature, true);
  ctlcloneFeature.setStyle(markerStyle);
}

function ControleEndUpdated() {
  ctlFeature.setStyle(markerUpdatedStyle);
}

function historyCenter() {
  goToControle(ControleCoordReproj);
}

function init(options) {
  ControleCoordReproj = fromLonLat(options.coord).map(function (val) {
    return val.toFixed(12);
  });
  geocodingApiUrl = options.geocodingApiUrl;
  secteurs = options.secteurs;
  zones = options.zones;
  onAddressChange = options.onAddressChange;
  onCoordsChange = options.onCoordsChange;
  onMapMatchingProcess2 = options.onMapMatchingProcess2;
  onSectorChange = options.onSectorChange;
  onZoneChange = options.onZoneChange;
  dedicatedStreetNumber = options.dedicatedStreetNumber;

  var aerialLayer = new TileLayer({
    source: new XYZ({
      url: "https://services.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",
      maxZoom: options.maxSatelliteZoom || 19,
    }),

    title: "Satellite",
  });

  map = new Map({
    target: document.getElementById("map"),
    controls: defaultControls().extend([
      new HistoryControl({
        center: ControleCoordReproj,
        zoom: options.zoom,
        callback: historyCenter,
      }),
    ]),
    layers: [aerialLayer],
    view: new View({
      center: options.center,
      maxZoom: options.maxZoom,
      zoom: options.zoom,
    }),
  });

  var raster = new TileLayer({
    source: new OSM(),
    title: "OpenStreetMap",
  });
  map.addLayer(raster);

  layerSwitcher = new LayerSwitcher({});

  initStyle(zones, secteurs, function () {
    map.getView().setCenter(ControleCoordReproj);
    map.getView().setZoom(zoomMax);

    async function loadLayers() {
      var arrayLayers = addLayers(map, options.layers, options.projection);
      Promise.all(arrayLayers).then(() => {
        mapMatchingProces(ControleCoordReproj);
      });
    }
    loadLayers();
  });
}

function setTarget(t) {
  if (map) map.setTarget(t);
}

function updateSize() {
  if (map) setTimeout(() => map.updateSize());
}

function addressUpdated(address, city, postalCode) {
  var fullAddress = address + " " + city + " " + postalCode;
  simpleGeocoding(geocodingApiUrl, fullAddress, function (json) {
    if (json.features.length === 0) return;

    var coord = json.features[0].geometry.coordinates;
    var coordinate = fromLonLat(coord).map(function (val) {
      return val.toFixed(12);
    });

    onCoordsChange(coord);
    goToControle(coordinate);

    ControleBeginUpdated();
    ctlFeature.getGeometry().setCoordinates(coordinate);
    ControleEndUpdated();

    mapMatchingProces2(coordinate);
    onMapMatchingProcess2();
  });
}

function newControleFeature(coord) {
  ControleCoordReproj = fromLonLat(coord).map(function (val) {
    return val.toFixed(12);
  });

  ctlFeature.getGeometry().setCoordinates(ControleCoordReproj);
  ctlcloneFeature.getGeometry().setCoordinates(ControleCoordReproj);

  featureVisible(ctlcloneFeature, false);
  ctlFeature.setStyle(markerStyle);
  cloning = true;

  goToControle(ControleCoordReproj, true);
  setTimeout(function () {
    mapMatchingProces(ControleCoordReproj);
  }, 1000);
}

function clearMap() {
  map = undefined;

  ControleCoordReproj = undefined;

  ctlFeature = null;
  ctlcloneFeature = null;
  cloning = true;
  vectorSource = null;

  geocodingApiUrl = undefined;
  secteurs = undefined;
  zones = undefined;
  onAddressChange = undefined;
  onCoordsChange = undefined;
  onSectorChange = undefined;
  onZoneChange = undefined;
  onMapMatchingProcess2 = undefined;

  currentSecteur = null;
  currentPlaceFeature = null;
  currentZone = null;
}

function hideLayerSwitcher() {
  if (map !== undefined && layerSwitcher !== undefined) {
    map.removeControl(layerSwitcher);
  }
}

function showLayerSwitcher() {
  if (map !== undefined && layerSwitcher !== undefined) {
    map.addControl(layerSwitcher);
  }
}

export {
  addressUpdated,
  clearMap,
  history,
  init,
  initControleFeature,
  newControleFeature,
  updateSecteur,
  setTarget,
  updateSize,
  hideLayerSwitcher,
  showLayerSwitcher,
};
